/**
 * French texts for every label the library renders itself. Typed as the full
 * `Texts`, so a key added to the library fails the build until it is translated
 * here. Pass to <TextsProvider texts={frenchTexts}> (or via textsFor("fr")).
 */
export const frenchTexts = {
    close: "Fermer",
    loading: "Chargement",
    retry: "Réessayer",
    unknownError: "Erreur inconnue",
    requestId: "ID de requête",
    notifications: "Notifications",
    confidence: "Fiabilité",
    loadErrorTitle: "Une nouvelle version est disponible",
    loadErrorText: "Une partie de l’application n’a pas pu être chargée, le plus souvent parce qu’une nouvelle version vient d’être déployée ou que la session a expiré. Recharger règle le problème ; votre travail est enregistré.",
    renderErrorTitle: "Cette vue n’a pas pu être affichée",
    renderErrorText: "Une erreur est survenue à l’affichage. Rechargez ou revenez à la page d’accueil ; rien de ce qui est enregistré n’est perdu.",
    reload: "Recharger",
    home: "Page d’accueil",
    technicalDetail: "Détail technique",
    ageNow: "à l’instant",
    ageMin: "min",
    ageHour: "h",
    ageDay: "j",
    cancel: "Annuler",
    rename: "Renommer",
    delete: "Supprimer",
    renameFailed: "Échec du renommage",
    deleteFailed: "Échec de la suppression",
    untitled: "Sans titre",
    confirmTitle: "Veuillez confirmer",
    confirmOk: "Confirmer",
    assistantName: "Assistant IA",
    assistantMark: "IA",
    assistantClose: "Fermer l’assistant IA (Échap)",
    assistantTyping: "L’assistant IA écrit",
    assistantThinking: "Réflexion…",
    assistantReasoning: "Raisonnement",
    assistantToolRunning: "Recherche :",
    assistantToolError: "Impossible :",
    assistantToolDone: "Consulté :",
    assistantCopy: "Copier",
    assistantCopied: "Copié",
    assistantCopyAnswer: "Copier la réponse",
    assistantSend: "Envoyer",
    assistantSendTitle: "Envoyer (Entrée)",
    assistantStop: "Arrêter la réponse",
    assistantMessageLabel: "Message à l’assistant IA",
    assistantPlaceholder: "Demandez à l’assistant IA …",
    assistantAborted: "Arrêté",
    assistantStreamError: "Erreur de l’assistant IA",
    assistantEmptyTitle: "Comment puis-je aider ?",
    assistantEmptyText: "Vous exécutez vous-même les suggestions d’un clic.",
    assistantContinue: "Continuer",
    assistantShowAll: "Afficher toutes les conversations",
    assistantProposals: "Suggestions à exécuter",
    assistantProposalRun: "Exécuter la suggestion de l’assistant IA",
    assistantProposalFailed: "Échec de l’exécution – réessayer",
    assistantProposalDone: "exécuté",
    assistantConversations: "Conversations",
    assistantEarlier: "Conversations précédentes",
    assistantHistory: "Historique",
    assistantAllOnPage: "Toutes sur une page",
    assistantNewConversation: "Nouvelle conversation",
    assistantNew: "Nouveau",
    assistantSearch: "Rechercher dans les conversations …",
    assistantNoConversations: "Aucune conversation pour l’instant",
    assistantNoMatch: "Aucune conversation correspondante",
    assistantNewTitle: "Nouveau titre",
    assistantMessagesShort: "msg",
    assistantContextSession: "Avec contexte",
    assistantGeneralSession: "Général",
    assistantWider: "Plus large",
    assistantNarrower: "Plus étroit",
    assistantOpenPage: "Ouvrir en page",
    assistantResize: "Redimensionner l’assistant IA (flèches, double-clic : large/étroit)",
    assistantResizeTitle: "Glisser pour redimensionner · double-clic : large/étroit",
    assistantKeySend: "envoyer",
    assistantKeyNewline: "nouvelle ligne",
    assistantKeyClose: "fermer",
    assistantToday: "Aujourd’hui",
    assistantYesterday: "Hier",
    assistantLast7: "7 derniers jours",
    assistantOlder: "Plus ancien",
    assistantAttach: "Ajouter une image",
    assistantCamera: "Prendre une photo",
    cameraTitle: "Prendre une photo",
    cameraPreview: "Aperçu de la caméra",
    cameraStarting: "Démarrage de la caméra …",
    cameraLive: "Caméra prête. Appuyez sur le déclencheur pour prendre la photo.",
    cameraShutter: "Prendre la photo",
    cameraTaken: "Photo prise",
    cameraRetake: "Reprendre",
    cameraUse: "Utiliser la photo",
    cameraSwitch: "Changer de caméra",
    cameraFallback: "Choisir un fichier à la place",
    cameraDenied: "L'accès à la caméra a été refusé. Autorisez-le dans les paramètres du site du navigateur, ou choisissez un fichier.",
    cameraNone: "Aucune caméra trouvée. Choisissez un fichier à la place.",
    cameraBusy: "La caméra est utilisée par une autre application. Fermez-la, ou choisissez un fichier.",
    cameraFailed: "La caméra n'a pas pu démarrer. Choisissez un fichier à la place.",
    assistantRemoveAttachment: "Retirer l’image",
    assistantDropImages: "Déposez les images ici",
    assistantAttachmentType: "Ce format d’image n’est pas pris en charge",
    assistantAttachmentSize: "L’image est trop grande",
    assistantAttachmentCount: "{n} images au maximum par message",
    assistantAttachmentFailed: "L’image n’a pas pu être envoyée",
    assistantPreparing: "Préparation de l’image …",
    assistantUploading: "Envoi …",
    assistantImage: "Image",
    assistantImageTitle: "Question avec photo",
    assistantOpenImage: "Agrandir l’image",
    assistantSteps: "Étapes ({n})",
    assistantStillWorking: "Toujours en cours : {step}",
    assistantStillWorkingPlain: "Toujours en cours …",
    assistantLookingAtImage: "Analyse de l’image …",
    assistantUploadProgress: "Envoyé : {percent} %",
    back: "Retour",
    next: "Suivant",
    done: "Terminé",
    skip: "Passer",
    no: "Non",
    search: "Rechercher",
    paletteLabel: "Palette de commandes",
    palettePlaceholder: "Rechercher ou saisir une commande …",
    paletteResults: "Résultats",
    paletteSelect: "choisir",
    paletteRun: "exécuter",
    shortcutsTitle: "Raccourcis clavier",
    keyCtrl: "Ctrl",
    userMenu: "Menu utilisateur",
    theme: "Apparence",
    themeLight: "Clair",
    themeDark: "Sombre",
    themeSystem: "Système",
    themeLightTitle: "Toujours clair",
    themeDarkTitle: "Toujours sombre",
    themeSystemTitle: "Suit le système d’exploitation et change avec lui",
    logout: "Se déconnecter",
    tourClose: "Terminer la visite",
    tourCloseTitle: "Terminer la visite (Échap)",
    tourStepOf: "Étape {n} sur {total}",
    tourTryIt: "Essayez :",
    tourLocked: "Verrouillé pendant la visite",
    helpTitle: "Aide & apprentissage",
    helpSubtitle: "Parcours d’apprentissage, visites guidées et manuel de chaque fonction",
    helpPath: "Parcours",
    helpTours: "Visites",
    helpHandbook: "Manuel",
    helpSearch: "Rechercher dans le manuel",
    helpSearchPlaceholder: "Rechercher dans le manuel …",
    helpIntro: "Voir l’introduction",
    helpReset: "Réinitialiser la progression",
    helpResetConfirm: "Vraiment réinitialiser la progression ?",
    helpResetYes: "Oui, réinitialiser",
    helpNoResults: "Rien trouvé. Essayez un autre mot.",
    pathTitle: "Votre parcours d’apprentissage",
    pathOf: "sur {total}",
    pathMoodStart: "Chaque tâche ne prend qu’un instant. La plupart se font en travaillant.",
    pathMoodHalf: "Plus de la moitié est faite. Le reste vient presque tout seul en travaillant.",
    pathMoodGoing: "Bon début. Continuez, une tâche après l’autre.",
    pathMoodDone: "Tout est appris. Vous connaissez maintenant chaque fonction.",
    taskDone: "fait",
    taskOpen: "à faire",
    taskDoneAt: "Fait le {date}",
    toursIntro: "Une visite met en avant une zone après l’autre et l’explique directement dans l’application. Les boutons sont verrouillés pendant la visite : rien ne peut être déclenché par erreur. [→] et [←] pour naviguer, [Échap] pour terminer.",
    tourDoneBadge: "fait",
    tourMeta: "{minutes} min · {steps} étapes",
    tourStart: "Démarrer",
    tourAgain: "Recommencer",
    articleTip: "Astuce :",
    articleTourText: "Vous préférez qu’on vous montre ? La visite vous guide dans cette zone.",
    articleTourStart: "Démarrer la visite",
    articleRelated: "À voir aussi",
    learnedTitle: "Appris : {title}",
    learnedProgress: "Parcours {done} sur {total}",
    learnedAllTitle: "Parcours terminé",
    learnedAllText: "Vous connaissez maintenant chaque fonction.",
    welcomeLabel: "Introduction",
    welcomePages: "Pages de l’introduction",
    welcomePage: "Page {n}",
    welcomeBrowse: "feuilleter",
    document: "Document",
    docPageShort: "p.",
    docPages: "Pages",
    docPageLabel: "Page {n}",
    docPageError: "La page {n} n’a pas pu être chargée",
    zoomIn: "Agrandir",
    zoomOut: "Réduire",
    zoomFit: "Ajuster à la largeur",
    docWider: "Afficher le document en large",
    docNarrower: "Réduire à nouveau le document",
    docOpenOriginal: "Ouvrir l’original",
    docClose: "Fermer le document",
    docNoEvidence: "aucune preuve dans le document",
    docApprox: "manuscrit · position approximative, p. {page} – à comparer avec le document",
    docApproxShort: "manuscrit",
    docApproxTitle: "{label} · manuscrit, position approximative",
    docMarkLabel: "Preuve pour {label}",
    docOcr: "OCR",
    docOcrTitle: "Page numérisée – texte reconnu par OCR",
    docWorkingTitle: "Lecture du document …",
    docWorkingText: "Les images des pages apparaissent dès que l’extraction est terminée.",
    docNoPages: "Aucune image de page",
    docNoPagesText: "L’original peut être affiché via « Ouvrir l’original ».",
    signingIn: "Connexion en cours",
    checkingAccess: "Vérification de l’accès",
    noAccessTitle: "Pas encore d’accès à cette application",
    noAccessText: "La connexion a réussi, mais aucun rôle n’est encore attribué à votre compte pour cette application.",
    signedInAs: "Connecté en tant que",
    email: "E-mail",
    signedInVia: "via",
    howToAccess: "Comment obtenir l’accès",
    howToAccessText: "Les rôles sont attribués par l’IT. Demandez-lui l’un de ces rôles :",
    copyRequest: "Copier la demande",
    copied: "Copié",
    signInAgain: "Rôle obtenu ? Se reconnecter",
    noAccessNote: "Les rôles sont pris en compte à la connexion. Après l’attribution, reconnectez-vous une fois ; pour un autre compte, passez par « Se déconnecter ».",
    // Lumi
    lumiMoodIdle: "{assistant} est là pour aider",
    lumiMoodListening: "{assistant} écoute",
    lumiMoodWorking: "{assistant} travaille",
    lumiMoodSpeaking: "{assistant} répond",
    lumiMoodGuiding: "{assistant} vous guide",
    lumiMoodGuidingStep: "{assistant} vous guide : étape {n}, {title}",
    lumiMoodCareful: "Prudence : confirmez d'abord l'étape de sécurité",
    lumiMoodSolved: "Résolu",
    lumiSourceOpen: "Ouvrir {name}",
    lumiSources: "Sources",
    lumiMoreSources: "Autres sources",
    lumiWebSources: "Depuis le web",
    lumiWhy: "Pourquoi",
    lumiWorked: "Ça a marché",
    lumiNotWorked: "Ça n'a pas marché",
    lumiSavedForTeam: "Enregistrée pour votre équipe",
    lumiOriginKB: "Issu de vos documents",
    lumiOriginWeb: "Depuis le web",
    lumiOriginMixed: "Documents et web",
    lumiOriginGeneral: "Connaissances générales, pas issues de vos documents",
    lumiSolutionsFound: "{n} solutions possibles",
    lumiGuideTitle: "Dépannage guidé",
    lumiGuideStepOf: "Étape {n} sur environ {m}",
    lumiGuideOpen: "Ouvrir le dépannage guidé",
    lumiGuideSolved: "Résolu",
    lumiGuideHandover: "Transmis",
    lumiGuideNotSolved: "Non résolu",
    lumiGuideDanger: "Danger",
    lumiGuideCaution: "Attention",
    lumiGuideSafetyConfirm: "J'ai lu, la machine est en sécurité",
    lumiGuideSafetyConfirmed: "Sécurité confirmée",
    lumiGuideExpected: "Vous devriez voir",
    lumiGuideFigure: "Figure",
    lumiGuideAnswers: "Votre réponse",
    lumiGuideHistory: "Étapes",
    lumiGuideStateDone: "fait",
    lumiGuideStateCurrent: "étape en cours",
    lumiGuideStateUpcoming: "à venir",
    lumiGuideAdapts: "Les étapes suivantes s'adaptent à vos réponses.",
    lumiGuideViewSwitch: "Dépannage guidé ou discussion",
    lumiGuideTab: "Guide",
    lumiChatTab: "Discussion",
    lumiHandoverTitle: "Résumé de transmission",
    lumiHandoverIntro: "Le dépannage n'est pas terminé. Transmettez ceci à un collègue ou au service.",
    lumiHandoverSymptom: "Symptôme",
    lumiHandoverSteps: "Étapes essayées et résultats",
    lumiHandoverPhotos: "{n} photos dans la conversation",
    lumiHandoverSources: "Pages de manuel",
    lumiHandoverNotAnswered: "sans réponse",
    lumiHandoverSummary: "Résumé",
    lumiHandoverCopy: "Copier",
    lumiHandoverShare: "Partager",
    lumiHandoverCopied: "Résumé copié.",
    lumiHandoverCopyFailed: "Le résumé n'a pas pu être copié.",
    lumiMachine: "Machine",
    lumiNoMachine: "Aucune machine indiquée",
    lumiFilterChoose: "Choisir la machine",
    lumiFilterChange: "Changer de machine",
    lumiFilterFor: "Pour {label}",
    lumiFilterRemove: "Retirer le filtre machine",
    lumiFieldSolution: "Solution terrain",
};
